var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg-wpp",on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/images/whatsapp.png"),"alt":"Guiia Tour"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }